/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/arrow-left-right
 */
import { default as DefaultIcon } from '~icons/lucide/arrow-left-right';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const ArrowLeftRightIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
